var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notifications',{attrs:{"classes":"info-notification","position":"bottom right","animation-name":"v-fade-left","width":500}})}
var staticRenderFns = []

export { render, staticRenderFns }